import { Component, OnInit, ViewChild, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { HealthService } from '../health.service';
import { Insurance } from '../health.model';
import { YearService } from '../../../shared-components/year/year.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-insurance',
    templateUrl: './insurance.component.html',
    styles: []
})
export class InsuranceComponent implements OnInit, OnChanges, OnDestroy {

    @Input() selectedStudent;
    isBusy = false;
    insurance: Insurance[] = [];
    student360YearSubscription: Subscription;

    // ----------Angular Material------------------------------------
    angularMatData = new TylerMatTableDataSource();
    displayedInsuranceColumn = ['InsuranceCompany', 'Policy', 'InsuranceStartDate', 'InsuranceEndDate'];
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private healthService: HealthService,
        private yearService: YearService
    ) {
        this.angularMatData = new TylerMatTableDataSource(this.insurance);

        this.student360YearSubscription = this.yearService.observableStudent360YearStream$.subscribe(() => {
            this.getInsurance();
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedStudent.previousValue != undefined) {
            if (changes.selectedStudent.currentValue.Id != changes.selectedStudent.previousValue.Id) {
                this.getInsurance();
            }
        }
    }

    ngOnInit() {
        this.getInsurance();
    }

    ngOnDestroy() {
        this.student360YearSubscription.unsubscribe();
    }

    getInsurance() {
        this.isBusy = true;
        setTimeout(() => {
            this.healthService.getInsurance(this.selectedStudent.Id, this.yearService.student360Year.Id).subscribe(data => {
                this.insurance = data;
                this.loadInsuranceHistory();
            });
        }, 0);
    }

    loadInsuranceHistory(): void {
        this.angularMatData = new TylerMatTableDataSource(this.insurance);
        setTimeout(() => {
            this.angularMatData.sort = this.sort;
        }, 0);
        this.isBusy = false;
    }

    // ------------Aria/Accessibility---------------------------
    getInsuranceAriaRow(row: Insurance): string {
        const colList: string[] = ['InsuranceCompany', 'Policy', 'InsuranceStartDate', 'InsuranceEndDate'];
        const dataList: string[] = [row.InsuranceCompany, row.Policy, row.InsuranceStartDate.toString(), row.InsuranceEndDate.toString()];

        return AriaDirective.concatAriaStrings(colList, dataList);
    }
}
